<script>
import ConnectionHealth from '@components/safehaven/connection-hub/connected-health.vue'
import ConnectedDeviceList from '@components/safehaven/connection-hub/connected-device-list.vue'
import ComingSoonTooltip from '@components/tooltips/coming-soon-tooltip.vue'

export default {
  page: {
    title: 'Connection Hub - All your health information in one secure place.',
    meta: [
      {
        name: 'description',
        content: 'All your health information in one secure place.',
      },
    ],
  },
  components: {
    ComingSoonTooltip,
    ConnectionHealth,
    ConnectedDeviceList,
  },
  data() {
    return {
      url: '',
      loading: false,
      loadIframe: false,
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    connectToProvider() {
      this.loading = true
      this.loadIframe = true
      this.loading = false
    },
  },
}
</script>

<template>
  <v-container :class="$style.pageContainer">
    <div :class="$style.pageTitle">
      <v-avatar class="mr-2" size="24">
        <v-img
          width="24"
          :src="
            require('@assets/images/safehaven/menu_icons/connection-hub.svg')
          "
        ></v-img>
      </v-avatar>
      <span>Connection Hub</span>
    </div>
    <p :class="$style.pageDesc">
      Securely connect all your healthcare information to get comprehensive
      feedback on the status of your health and guidance to your next best
      health action.
    </p>
    <div>
      <div class="mt-0">
        <div :class="[$style.card, 'mr-1 my-1 pa-5']">
          <div class="d-flex" :class="$style.serviceSection">
            <v-img
              v-if="!mobile"
              width="140"
              height="134"
              class="flex-grow-0 mr-5"
              contain
              :src="
                require('@assets/images/safehaven/connection-hub/smartwatch.svg')
              "
            ></v-img>
            <div class="flex-grow-1">
              <div
                :class="[
                  $style.serviceTitle,
                  'd-flex flex-row align-center mb-2',
                ]"
              >
                <v-img
                  class="flex-grow-0 mr-1"
                  :src="
                    require('@assets/images/safehaven/connection-hub/smartwatch-icon.svg')
                  "
                  width="18"
                  height="18"
                  contain
                />
                <span class="flex-grow-1">Devices & Apps</span>
              </div>
              <div :class="$style.serviceDesc">
                Integrate your smart watch, fitness tracker or health app to
                track and analyze your health progress.
              </div>
              <ConnectedDeviceList />
              <p :class="[$style.serviceDownload, 'mb-0']">
                <a :class="$style.serviceDownloadLink"
                  >Download the HB+ mobile app</a
                >
                to connect/disconnect Apple Health or Google Fit
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3">
        <div :class="[$style.card, 'mr-1 my-1 pa-5']">
          <div class="d-flex" :class="$style.serviceSection">
            <v-img
              v-if="!mobile"
              width="140"
              height="134"
              class="flex-grow-0 mr-5"
              contain
              :src="
                require('@assets/images/safehaven/connection-hub/records.svg')
              "
            ></v-img>
            <div class="flex-grow-1">
              <div
                :class="[
                  $style.serviceTitle,
                  'd-flex flex-row align-center mb-2',
                ]"
              >
                <v-img
                  class="flex-grow-0 mr-1"
                  :src="
                    require('@assets/images/safehaven/connection-hub/records-icon.svg')
                  "
                  width="18"
                  height="18"
                  contain
                />
                <span class="flex-grow-1">Health Records</span>
              </div>
              <div :class="$style.serviceDesc">
                Consolidate your electronic health records to they can be
                analyzed for potential health risks.
              </div>
              <ConnectionHealth :is-show="loadIframe" />
              <div class="mt-7 mb-3">
                <a
                  :class="[$style.serviceAddConnect, 'py-3']"
                  @click="connectToProvider"
                  >Add Connection</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="my-3">
        <div :class="[$style.card, 'mr-1 my-1 pa-5']">
          <div class="d-flex" :class="$style.serviceSection">
            <v-img
              v-if="!mobile"
              width="140"
              height="134"
              class="flex-grow-0 mr-5"
              contain
              :src="
                require('@assets/images/safehaven/connection-hub/insurance.svg')
              "
            ></v-img>
            <div class="flex-grow-1">
              <div
                :class="[
                  $style.serviceTitle,
                  'd-flex flex-row align-center mb-2',
                ]"
              >
                <v-img
                  class="flex-grow-0 mr-1"
                  :src="
                    require('@assets/images/safehaven/connection-hub/insurance-icon.svg')
                  "
                  width="18"
                  height="18"
                  contain
                />
                <span class="flex-grow-1">Insurance</span>
              </div>
              <div :class="$style.serviceDesc">
                Connect your insurance portal to include your benefits and
                claims information all in one place.
              </div>
              <ComingSoonTooltip left>
                <a :class="[$style.comming, 'py-3']"> Add Connection </a>
              </ComingSoonTooltip>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <p :class="$style.privacytext">
        Your privacy is our priority. Your health data will not be sold or used
        without your consent. View our
        <router-link :to="{ name: 'healthbookplus-privacy' }"
          >Privacy Policy</router-link
        >
      </p>
      <div :class="$style.iconcontainer">
        <div class="mr-4">
          <v-img
            max-width="40"
            :src="require('@assets/images/safehaven/HIPAA.png')"
          />
        </div>
        <div class="mr-4">
          <v-img
            width="50"
            :src="require('@assets/images/safehaven/SOC2.png')"
          />
        </div>
        <div>
          <v-img
            width="86"
            :src="require('@assets/images/safehaven/SSL.png')"
          />
        </div>
      </div>
    </div>
    <!-- <ConnectionHealth /> -->
  </v-container>
</template>

<style lang="scss" module>
.pageContainer {
  padding-top: 50px !important;
  margin: 0 120px !important;
}
.boldText {
  font-weight: 700;
}
.pageTitle {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 700;
  color: #000;
}
.pageDesc {
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #000;
}

.card {
  background: #fff;
  border: 1px solid #93c0e8;
  border-radius: 4px;
}
.serviceTitle {
  font-size: 18px;
  font-weight: 700;
  line-height: 21px;
  color: #3d3d3d;
}

.serviceDesc {
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #7a7a7a;
}

.serviceAddConnect {
  display: block;
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  color: #057cfc;
}

.serviceDownload {
  font-size: 11px;
  font-weight: 400;
  color: #000;
}
.serviceDownloadLink {
  color: #057cfc;
}
.serviceSection {
  cursor: pointer;
}

.comming {
  display: block;
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  color: #aaa !important;
}

.iconcontainer {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.privacytext {
  margin: 23px 0 !important;
  font-size: 12px;
}

@media screen and (max-width: 1260px) {
  .pageContainer {
    max-width: 1200px;
    padding-top: 50px !important;
    margin: 0 60px !important;
  }
}

@media screen and (max-width: 959px) {
  .pageContainer {
    padding-top: 50px !important;
    margin: 0 20px !important;
  }
}

@media screen and (max-width: 450px) {
  .pageContainer {
    padding-top: 20px !important;
    margin: 0 10px !important;
  }
}
</style>
